<template>
   <div class="container px-0 bg-danger">
   <div class="offcanvas offcanvas-end rounded-2 bg-l-gray" 
         data-bs-scroll="true" 
         data-bs-backdrop="true" 
         tabindex="-1" 
         id="offcanvasAttach" 
         aria-labelledby="offcanvasAttachLabel"
         @blur="focusOff()"
         @focus="focusOn()"
      >
      <!--
         data-bs-backdrop="false" 
         @blur="focusOff()"
      -->
      <div class="offcanvas-header">
         <h6 id="offcanvasAttachLabel">Adjuntos ({{cnttId}})</h6>
         <button type="button" 
            id="btn_close_offcanvas"
            class="btn-close btn-sm text-reset" 
            data-bs-dismiss="offcanvas" 
            aria-label="Close" 
            ref="btn_close_offcanvas"
         ></button>
      </div>
      <hr class="m-0"/>
      <div class="offcanvas-body">
         <input v-show="!selectedFiles" type="file" id="fileToUpload" ref="file" @change="selectFile" @blur="focusOut()" />
         <div v-if="selectedFiles">
            <ul class="list-group pb-2">
               <li class="list-group-item">
                  Archivo seleccionado: <b>{{file.files.item(0).name}}</b>
               </li>
            </ul>
            <div class="btt-attach btn-save rounded" @click="upload">
               Adjuntar
            </div>
         </div>
      </div>
   </div>
   </div>
   <!--
    <button class="btn btn-success" :disabled="!selectedFiles" @click="upload">
         <label class="col-12 bg-light rounded-3 border p-2">
            <input type="file" id="fileToUpload" ref="file" @change="selectFile" />
         </label>
   -->
</template>

<script>
//import { ref, watchEffect, nextTick } from 'vue';
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'

import WspService from "../workSpace/workSpace.service";

export default {
   
   setup() {
      const store = useStore()

      const cnttId = ref(store.state.wspace.contentId)
      const cellId = ref(0)
      const content = ref({})
      const file = ref(null)
      const selectedFiles = ref(undefined)
      const showInput = ref(false)

      onMounted(() => {
         let myOffCanvas = document.getElementById('offcanvasAttach')
         myOffCanvas.addEventListener('shown.bs.offcanvas', function (event) {
         // do something...
         console.log(store.state.wspace.contentId)
         cnttId.value = store.state.wspace.contentId
         let button = event.relatedTarget
         cellId.value = button.getAttribute('data-cell-id')
         //document.getElementById('fileToUpload').reset()
         //console.log(" show fileToUpload:" + document.getElementById('fileToUpload').files[0])
         //file.value = null
         getContent(cnttId.value)
         myOffCanvas.focus()
         //file.value = {}
         console.log(" show Attach's OC")
         selectedFiles.value = false
         document.getElementById('fileToUpload').value = null
         document.getElementById('fileToUpload').click()
         })
         console.log("Attach's OC")
      })
      
      function getContent(contentId) {
         WspService.getContent(contentId)
         .then(response => {
            console.log(response.data)
            content.value = response.data
            console.log("content ok: "+content.value.title)
         })
         .catch(error => {
            console.log(error);
         });
      }
      
      function focusOff() {
         console.log('out-focus-offcanvas')
         //
         store.dispatch("wspace/setOffCanvas", 6)
         //setTimeout(btn_out_offcanvas.value.click(),125)
         //
      }
      
      function focusOut() {
         console.log('out-focus-input-type-file')
      }

      function focusOn() {
         console.log('in-focus-offcanvas')
      }

      function selectFile() {
         console.log("selected file: " + file.value.files.item(0).name)
         selectedFiles.value = file.value.files
      }

      function upload() {
         //
         /*
         WspService.addAttachContent(
            cnttId.value,     // contentId, 
            store.state.auth.user.id,     // userId, 
            "cualquier verdura"    // selectedFiles.value.item[0]   // attachFile
            )
            */
         WspService.addAttachContent(
            selectedFiles.value.item[0]   // attachFile
            )
         .then(response => {
            
            console.log(response.data)
            /*
            content.value = response.data
            */
            console.log("attach ok: ")
         })
         .catch(error => {
            console.log(error);
         });
         //
         selectedFiles.value = false
         document.getElementById('fileToUpload').value = null
      }

      return {
         cnttId,
         content,
         file,
         focusOn,
         focusOut,
         focusOff,
         selectFile,
         selectedFiles,
         showInput,
         upload
      }
   }
}
</script>

<style scoped>
@media (min-width: 768px) {
   .offcanvas-end {
   top: 25px;
   right: 100px;
   width: 600px;
   height: fit-content;
   }
}
@media (max-width: 767px) {
   .offcanvas-end {
   top: 25px;
   right: 10%;
   width: 80%;
   height: fit-content;
   }
}
.btn-info {
   background-color: #e5e7e9;
   border-color: #e5e7e9 ;
}
.btn-info:hover {
   background-color:  #cacfd2 ;
}
.btn-save {
   opacity: .7;
   background-color: blue;
   color: white;
}
.btn-save:hover {
   opacity: 1;
}
.btn-sm {
   width: max-content;
}
.bg-l-gray {
   background-color:  #ecf0f1 ;
}
.btt-attach {
  height: 30px;
  text-align: center;
}
.tc-gray {
   color: gray;
}
.fs-11 {
   font-size: 11px;
}
</style>